<template>
  <div>
    <button>qwwqwqw</button>
    <GfColorPicker />
  </div>
</template>

<script>
export default {
  name: 'GfButtonColorPicker',
};
</script>
